export var ColorChartsActionTypes;
(function (ColorChartsActionTypes) {
    ColorChartsActionTypes["FETCH_COLORCHARTS_ATTEMPT"] = "FETCH_COLORCHARTS_ATTEMPT";
    ColorChartsActionTypes["FETCH_COLORCHARTS_SUCCESS"] = "FETCH_COLORCHARTS_SUCCESS";
    ColorChartsActionTypes["FETCH_COLORCHARTS_FAILURE"] = "FETCH_COLORCHARTS_FAILURE";
})(ColorChartsActionTypes || (ColorChartsActionTypes = {}));
